module.exports = __webpack_public_path__ + "img/Group167.7a00cba1.png";